import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import useLocales from "src/hooks/useLocales";
import * as Yup from "yup";

import useChangePassword from "../service/useChangePassword";

export type ChangePasswordFormValues = {
	oldPassword: string;
	newPassword: string;
	confirmNewPassword: string;
};

export const useChangePasswordForm = () => {
	const { translate } = useLocales();

	const { isLoading, changePassword } = useChangePassword();

	const ChangePasswordSchema = Yup.object().shape({
		oldPassword: Yup.string().required("Contraseña antigua requerida"),
		newPassword: Yup.string()
			.required(translate("Contraseña nueva requerida"))
			.matches(
				/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-8])(?=.*[!@#$%^&*(),.?":{}|<>])(?!.*(.)\1{3})(?=.{8,30}$)/,
				translate(
					"La nueva contraseña debe tener al menos 8 caracteres, una letra mayúscula, un número, un caracter especial y no repetir la misma letra más de tres veces."
				)
			),
		confirmNewPassword: Yup.string()
			.required(translate("Contraseña nueva requerida"))
			.oneOf([Yup.ref("newPassword")], "Las contraseñas deben coincidir")
	});

	const defaultValues: ChangePasswordFormValues = {
		oldPassword: "",
		newPassword: "",
		confirmNewPassword: ""
	};

	const methods = useForm<ChangePasswordFormValues>({
		resolver: yupResolver(ChangePasswordSchema),
		defaultValues
	});

	const onSubmit = async (data: ChangePasswordFormValues) => {
		changePassword(data, methods.setError);
	};

	return {
		methods,
		isLoading,
		onSubmit: methods.handleSubmit(onSubmit)
	};
};
